module.exports = __webpack_public_path__ + "img/carousel-arrow-prev.6ca0d174.png";